import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  outstandingBalanceList: { loading: false, data: null, error: null },
};

export const OutstandingBalance = createSlice({
  name: "outstandingbalance",
  initialState,
  reducers: {
    fetchOutstandingBalanceListRequest: (state, action) => {
      state.outstandingBalanceList.loading = true;
      state.outstandingBalanceList.error = null;
    },
    fetchOutstandingBalanceListSuccess: (state, action) => {
      state.outstandingBalanceList.data = action.payload;
      state.outstandingBalanceList.loading = false;
      state.outstandingBalanceList.error = null;
    },
    fetchOutstandingBalanceListFailure: (state, action) => {
      state.outstandingBalanceList.data = null;
      state.outstandingBalanceList.loading = false;
      state.outstandingBalanceList.error = action.payload;
    },
  },
});

export const {
  fetchOutstandingBalanceListRequest,
  fetchOutstandingBalanceListSuccess,
  fetchOutstandingBalanceListFailure,
} = OutstandingBalance.actions;

export const getOutstandingBalanceListState = (store) =>
  store.outstandingbalance?.outstandingBalanceList;

export default OutstandingBalance.reducer;
